module.exports = __webpack_public_path__ + "img/item_Portrait_05.3a8d5a4b.jpeg";